import { FC } from 'react';

export const Footer: FC = () => {
    return (
        <footer>
            <div className='container'>
                <span>{'(c) wowhaus'}</span>
            </div>
        </footer>
    );
};
